export default __webpack_public_path__ + "static/media/Group11903b.d8350576.svg";